export default "//file.bilionpass.com/japandx-web/0.0.1/static/about-us.bc9fabd1-efbf05.gif";